<template>
  <div>
    <a-card
      size="small"
      title="基本信息"
      :headStyle="{
        background: '#f3f3f3',
      }"
    >
      <template v-slot:extra>
        <a-button @click="backPage">返回</a-button>
      </template>
      <a-row class="title_row">
        <a-col :span="12">
          <span class="clb">订单号：</span>
          {{ detail.orderCode }}
          <a-button type="primary" style="margin-left:10px" @click="associated">
            关联单
          </a-button>
          <a-button type="primary" style="margin-left:10px" @click="toSupply">
            供应单
          </a-button>
        </a-col>
        <a-col :span="12" style="color:red">
          <span class="clb">状态：</span>

          {{ changeState(detail) }}
        </a-col>
      </a-row>

      <a-row style="margin-top:20px">
        <a-col :span="6">
          <span class="clb">下单时间：</span>
          {{ detail.createTime }}
        </a-col>

        <a-col :span="6">
          <span class="clb">支付状态：</span>
          {{ detail.payStateValue }}
        </a-col>
        <a-col :span="6">
          <span class="clb">订单类型：</span>
          {{ detail.typeValue }}
        </a-col>
         <a-col :span="6">
                <span class='clb'>是否打印票根：</span>
             {{ detail.enterpriseCodeValue }}
         </a-col>
        <a-col :span="6">
          <span class='clb'>渠道单号：</span>
          {{ detail.channelCode }}
        </a-col>
        <a-col :span="6">
          <span class='clb'>供应商名称：</span>
          {{ detail.supplierName }}
        </a-col>
      </a-row>
      <a-row style="margin-top:20px">
        <a-col :span="6">
          <span class="clb">备注：</span>
          {{ detail.remark }}
        </a-col>
      </a-row>
    </a-card>

    <a-card
      size="small"
      title="订票信息"
      style="margin-top:20px"
      :headStyle="{
        background: '#f3f3f3',
      }"
    >
      <a-row>
        <a-col :span="12">
          <span class="clb">联系人：</span>
          {{ detail.contact }}
        </a-col>
        <a-col :span="12">
          <span class="clb">电话：</span>
          {{ detail.mobile }}
        </a-col>
      </a-row>
      <a-row style="margin-top:20px">
        <a-col :span="12">
          <span class="clb">总价：</span>
          <span
            >{{ detail.totalAmount }}（ 票款 ） +
            {{ detail.serviceAmount ? detail.serviceAmount : "0" }}（ 服务费 ）
            =
            <span style="color:red"
              >¥{{
                detail.totalAmount + detail.serviceAmount
              }}（ 应付 ）</span
            ></span
          >
        </a-col>

        <a-col :span="12">
          <span class='clb'>退差：</span>
          <span>{{(detail.payAmount-detail.serviceAmount)}}（ 收票款 ） - {{(detail.priceTicketTotal==null || detail.priceTicketTotal == 0)?(detail.payAmount-detail.serviceAmount):detail.priceTicketTotal}}（ 实际票款 ） =  <span style='color:red'>¥{{(detail.payAmount-detail.serviceAmount)-((detail.priceTicketTotal==null || detail.priceTicketTotal == 0)?(detail.payAmount-detail.serviceAmount):detail.priceTicketTotal)}}（ 差价 ）</span></span>

        </a-col>
      </a-row>
    </a-card>
    <a-card
      size="small"
      title="车票详情"
      style="margin-top:20px"
      :headStyle="{
        background: '#f3f3f3',
      }"
    >
      <template v-slot:extra>
        <a-button @click="handleSuccess">
          {{handleState.stateValueSuccess}}
        </a-button>
        <a-button style="margin-left: 20px;"  @click="handleFail">
          {{handleState.stateValueFail}}
        </a-button>
        <a-button style="margin-left: 20px;"  @click="queryTicketStatus">
          查询车票状态
        </a-button>
      </template>

      <a-row>
        <a-col :span="12" class="ticket">
          <div>
            {{ detail.fromStation }}
            <div class="time_div">{{ detail.fromTimeFormat }}</div>
          </div>
          <div class="line_content">
            <span>耗时{{ detail.takeTimeFormat }}</span>
            <span class="line"></span>
          </div>
          <div>
            {{ detail.toStation }}（<span style="color:red">{{
              detail.trainNo
            }}</span
            >）
            <div class="time_div">{{ detail.toTimeFormat }}</div>
          </div>
        </a-col>
        <!-- <a-col :span="12" style='text-align: right;' class='ticket_time'>
                    <div>
                        开车时间：{{detail.fromTimeFormat}}
                    </div>
                    <div>
                        到达时间：{{detail.toTimeFormat}}
                    </div>
                </a-col> -->
      </a-row>

      <a-table
        :columns="columns"
        bordered
        :data-source="detail.passengersList"
        :pagination="false"
        :row-key="(r) => r.id"
        :loading="loading"
        style="margin-top:20px"
        :row-selection="rowSelection"
      >
        <template v-for="col in ['orderTicketNo','ticketNo','lastCoach','lastSeat','ticketCheck','ticketLastPrice']" #[col]="{ text, record }" :key="col">
          <div>
            <a-input
                v-if="editableData[record.id]"
                v-model:value="editableData[record.id][col]"

            />
            <template v-else>
              {{ text }}
            </template>
          </div>
        </template>

      </a-table>

    </a-card>

    <a-card
        size="small"
        title="用户选座信息"
        style='margin-top:20px'
        :headStyle='{
                background : "#f3f3f3"
            }'
        class='logContent'>
      <a-table
          :columns="choosesSeatColumn"
          :row-key="(r) => r.id"
          bordered
          :data-source="chooseSeats"
          :pagination="false"
          :loading="loading"
      >
        <template v-slot:chooseSeats="{ text, record }">
          {{ record.chooseSeats === null || record.chooseSeats === '' ? "无" : record.chooseSeats }}
        </template>

        <template v-slot:acceptNoSeat="{ text, record }">
          {{ record.acceptNoSeat === 0 || record.acceptNoSeat === null? "否" : "是" }}
        </template>

        <template v-slot:chooseOther="{ text, record }">
          {{ record.chooseOther === 0 || record.chooseOther === null? "否" : "是" }}
        </template>
        <template v-slot:acceptNoTotal="{ text, record }">
          {{ record.acceptNoTotal === 0 || record.acceptNoTotal === null ? "否" : "是" }}
        </template>
      </a-table>

    </a-card>


    <df-orderLog :list="operationLogList"></df-orderLog>

    <a-modal v-model:visible="modalVisible" title="关联订单" :footer="null">
      <a-list
        item-layout="horizontal"
        :data-source="associateddata"
        class="a_list"
      >
        <template v-slot:renderItem="{ item, index }">
          <a-list-item>
            <div class="flex-row">
              <div>
                {{ associateValue[item.orderType] }}：<span
                  style="color:#1890ff;cursor:pointer"
                  @click="toRefoundDetail(item)"
                  >{{ item.orderCode }}</span
                >
              </div>
              <div>{{ item.amount }}</div>
            </div>

            <div class="flex-row">
              <div style="color:red">{{ item.stateValue }}</div>
              <div>{{ item.operationTime }}</div>
            </div>
          </a-list-item>
        </template>
      </a-list>
    </a-modal>



    <!-- 出票失败原因 -->
    <a-modal v-model:visible="createVisible" width="450px" @ok="failReason" title="请输入失败原因">
      <a-spin :spinning="createSpinning">
            <a-input
                v-model:value="failReasonInput.remark"
                placeholder="失败原因"
                allowClear
            />
      </a-spin>
    </a-modal>



  </div>
</template>

<script>
import shopApi from "@axios/shop";
import moment from "moment";
import { defineComponent, reactive, ref, UnwrapRef,toRaw   } from "vue";
import { useRoute, useRouter } from "vue-router";
import orderApi from "@axios/order";
import orderState from "@assets/static";
import { message , notification } from "ant-design-vue";
import staticEnum from "@assets/static";
import reactiveArray from "core-js/internals/array-iteration";

export default {
  name: "orderDetail",
  components: {},
  setup() {

    let loading = ref(false);
    const router = useRouter();
    let list = ref([]);
    const route = useRoute();
    const code = route.query.code;
    const flag = ref(route.query.flag);
    let detail = ref({});
    let modalVisible = ref(false);
    let chooseSeats = ref([]);
    let handleState = ref({});

    let operationLogList = ref([]);
    let extraChooseSeat = ref([]);

    let failReasonInput = ref({
      remark:""
    });

    const getDetail = (code) => {
      orderApi.getOrderDetail(code).then((res) => {

        res.passengersList.forEach(item=>{
          item.orderTicketNo = res.ticketNo
        })

        detail.value = res;
        chooseSeats.value.push(res);
        operationLogList.value = res.operationLogList;
        extraChooseSeat.value.push(res.extraChooseSeat);

        editableSetUp(res);
        orderStateBtn(res);
      });


    };
    getDetail(code);


    let ticketStatusReq = {
      "orderCode": "",
      "channelOrderCode": "1005619",
      "orderTime": "2024-03-13",
      "queryType": "4",
      "ticketNo": "",
      "trainNo": "",
      "fromStationName": "长春西",
      "toStationName": "大连北",
      "trainDate": "2024-03-16",
      "coachNo": "01车",
      "seatNo": "09F号",
      "certificateType": "1",
      "passengerName": "",
      "ticketType": "1"
    };

    let ticketStatusParams = ref([]);

    //人工处理占座失败或出票失败
    const queryTicketStatus = () => {
      console.log("ticketStatus---{}","车票状态")
      if (ticketStatusParams.value.length === 0){
        message.error("请先选择乘客");
      }else {

        ticketStatusParams.value.forEach(param => {
          ticketStatusReq.orderCode = param.orderCode
          ticketStatusReq.channelOrderCode = "Sys"+param.orderCode
          ticketStatusReq.certificateType = param.cardType
          ticketStatusReq.ticketType = param.passengerType
          ticketStatusReq.passengerName = param.passengerName

          console.log("tqueryTicketStatus--req-{}",ticketStatusReq)
          orderApi.queryTicketStatus(ticketStatusReq).then((res) => {
            console.log("tqueryTicketStatus--res-{}",res)
          });
        })

        message.success("已申请，前往车票状态页面查询结果");

      }

    }

    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        ticketStatusParams.value = selectedRows
        console.log('ticketStatusParams.valueselectedRows: ', ticketStatusParams.value);
      },
      onSelect: (record, selected, selectedRows) => {
        console.log(record, selected, selectedRows);
      },
      onSelectAll: (selected, selectedRows, changeRows) => {
        console.log(selected, selectedRows, changeRows);
      },
    };

    let associateValue = {
      10: "普通订单",
      20: "改签订单",
      30: "退票订单",
    };

    //当前订单详情状态
    let orderStateEnum = {
      created:10,
      booking:20,
      booked:30,
      issuing:40,
      issued:50,
      bookFail:60,
      issueFail:70,
      cancel:90
    };

    let associateddata = ref([]);

    const associated = () => {
      let params = {
        orderCode: detail.value.orderCode,
      };
      orderApi.associated(params).then((res) => {
        if (res.length) {
          modalVisible.value = true;
          associateddata.value = res;
        } else {
          message.error("未查询到关联单");
        }
      });
    };

    const toRefoundDetail = (item) => {
      let name = "orderDetail";
      if (item.orderType == 30) {
        name = "refundDetailIndex";
      }
      const newweb = router.resolve({
        name: name,
        query: {
          code: item.orderCode,
        },
      });
      window.open(newweb.href, "_blank");
    };

    const toSupply = (code) => {
      const newweb = router.resolve({
        name: "supplyDetailIndex",
        query: {
          code: detail.value.orderCode,
        },
      });
      window.open(newweb.href, "_blank");
    };

    const backPage = () => {
      router.back();
    };

    const changeState = (detail) => {
      if (detail.returnState == 10) {
        if (detail.changeState == 10) {
          return detail.orderStateValue;
        } else {
          return detail.changeStateValue;
        }
      } else {
        return detail.returnStateValue;
      }
    };

    const editableData = reactive({});

    const editableSetUp = (res) => {
       res.passengersList.forEach(item =>{
          editableData[item.id] = item
       })
    }

    //人工处理占座或出票成功
    const handleSuccess = () => {
      let param = detail.value;

      if (param.orderState === orderStateEnum.booking){
        param.orderState = orderStateEnum.booked
      }else if (param.orderState === orderStateEnum.issuing){
        param.orderState = orderStateEnum.issued
      }else {
        message.success("当前状态无需处理！");
        return;
      }
      orderApi.handleOrders(param).then((res) => {
        message.success("提交成功！");
        getDetail(code);
      });
      getDetail(code);
    }
    //人工处理占座失败或出票失败
    const handleFail = () => {
      showFailReasonInput();
      console.log("logggg---{}",createVisible.value)
    }



    const orderStateBtn = (res) => {

      if (res.orderState === orderStateEnum.booking){
        handleState.value.stateValueSuccess = '占座成功'
        handleState.value.stateValueFail = '占座失败'
      }else if (res.orderState === orderStateEnum.issuing){
        handleState.value.stateValueSuccess = '出票成功'
        handleState.value.stateValueFail = '出票失败'
      }else {
        handleState.value.stateValueSuccess = '无需处理'
        handleState.value.stateValueFail = '无需处理'
      }
    }


    //出票失败原因
    let createVisible = ref(false);
    //出票失败完毕
    let createSpinning = ref(false);
    const failReason = () => {

      let param = detail.value;

      param.remark = failReasonInput.value.remark

      if (param.orderState === orderStateEnum.booking){
        param.orderState = orderStateEnum.bookFail
      }else if (param.orderState === orderStateEnum.issuing){
        param.orderState = orderStateEnum.issueFail
      }else {
        message.success("当前状态无需处理！");
        return;
      }
      createVisible.value = false;
      createSpinning.value = false;

      orderApi.handleOrders(param).then((res) => {
        message.success("提交成功！");
        getDetail(code);
      });
      getDetail(code);
    }
    const showFailReasonInput = () => {
      createVisible.value = true;
    };
    const createCancel = () => {
      createVisible.value = false;
      createSpinning.value = false;
    };

    return {
      ticketStatusReq,
      ticketStatusParams,
      queryTicketStatus,
      rowSelection,
      failReasonInput,
      createCancel,
      failReason,
      showFailReasonInput,
      createSpinning,
      createVisible,
      orderStateEnum,
      handleState,
      handleFail,
      handleSuccess,
      editableData,
      //选座信息
      extraChooseSeat,
      flag,
      changeState,
      associateValue,
      operationLogList,
      backPage,
      toSupply,
      toRefoundDetail,
      associateddata,
      associated,
      modalVisible,
      orderState,
      activeKey: ["1"],
      loading,
      detail,
      chooseSeats,
      list,
      columns1: [
        { title: "订单号", dataIndex: "orderCode" },
        { title: "是否同车厢", slots: { customRender: "carriage" } },
        { title: "是否同包厢", slots: { customRender: "box" } },
        {
          title: "选座列表",
          dataIndex: "dseats",
          slots: { customRender: "seats" },
        },
        { title: "是否选面对面座位", slots: { customRender: "ftof" } },
        { title: "选座不成功时是否接受其他位置 ", slots: { customRender: "chooseOther" } },
        { title: "是否选同排", slots: { customRender: "sameRow" } },
        {
          title: "选铺位列表",
          dataIndex: "seats",
          slots: { customRender: "dseats" },
        },
        { title: "选座是否成功", slots: { customRender: "state" } },
        { title: "订单创建时间", slots: { customRender: "createtime" } },
      ],
      columns: [
        {
          title: "乘客id",
          dataIndex: "id",
          width: 100,
          align: "center",
        },
        {
          title: "乘客",
          dataIndex: "passengerName",
          width: 100,
          align: "center",
        },
        {
          title: "车票类型",
          dataIndex: "passengerTypeValue",
          width: 100,
          align: "center",
          slots: { customRender: "type" },
        },
        {
          title: "座席类型",
          dataIndex: "seatName",
          width: 100,
          align: "center",
          slots: { customRender: "seatName" },
        },
        {
          title: "取票号",
          dataIndex: "orderTicketNo",
          align: "center",
          slots: { customRender: "orderTicketNo" }
        },
        {
          title: "票号",
          dataIndex: "ticketNo",
          align: "center",
          slots: {
            customRender: 'ticketNo'
          }
        },
        {
          title: "车厢信息",
          dataIndex: "lastCoach",
          width: 100,
          align: "center",
          slots: { customRender: "lastCoach" },
        },
        {
          title: "座位",
          dataIndex: "lastSeat",
          width: 100,
          align: "center",
          slots: { customRender: "lastSeat" },
        },
        {
          title: "检票口",
          dataIndex: "ticketCheck",
          width: 100,
          align: "center",
          slots: {
            customRender: 'ticketCheck'
          }
        },
        {
          title: "出票票价",
          dataIndex: "ticketLastPrice",
          align: "center",
          slots: {
            customRender: 'ticketLastPrice'
          }
        },
        {
          title: "订票票价",
          dataIndex: "ticketSalePrice",
          align: "center",
          slots: {
            customRender: 'ticketSalePrice'
          }
        },
        {
          title: "手机号",
          dataIndex: "mobile",
          align: "center",
        },
        {
          title: "证件类型",
          dataIndex: "cardTypeValue",
          align: "center",
        },
        {
          title: "证件号",
          dataIndex: "cardNo",
          width: 200,
          align: "center",
        }
        /*, {
          title: '操作',
          dataIndex: 'operation',
          width: 100,
          align: "center",
          slots: { customRender: 'operation' },
        }*/
      ],
      choosesSeatColumn:[
        {
          title: "指定座位",
          dataIndex: "chooseSeats",
          width: 100,
          align: "center",
          slots: {customRender: "chooseSeats"}
        },
        {
          title: "接受无座",
          dataIndex: "acceptNoSeat",
          width: 100,
          align: "center",
          slots: {customRender: "acceptNoSeat"}
        },
        {
          title: "接受其他座位",
          dataIndex: "chooseOther",
          width: 100,
          align: "center",
        slots: {customRender: "chooseOther"}
        },{
          title: "接受部分出票",
          dataIndex: "acceptNoTotal",
          width: 100,
          align: "center",
          slots: {customRender: "acceptNoTotal"}
        }
      ]
    };
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.logitem {
  display: flex;
  justify-content: space-between;
}
.a_list /deep/ .ant-list-item {
  display: block !important;
  background: #eee !important;
  padding: 10px 10px;
  border-radius: 3px;
  margin-bottom: 20px;
}
.logContent /deep/ .ant-card-body {
  padding: 0 !important;
}
.log_content {
  margin-top: 20px;

  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.log_content /deep/ .ant-collapse-content-box {
  padding-bottom: 0 !important;
}

.log_content /deep/ .ant-timeline-item-content {
  min-height: auto !important ;
}
.log_content /deep/ .ant-card-body {
  padding-top: 30px;
  padding-bottom: 10px;
}
.clb {
  color: #000;
}
.title_row {
  line-height: 40px;
  font-size: 20px;
}
.ticket {
  display: flex;
  justify-content: flex-start;
  div {
    margin-right: 30px;

    font-size: 20px;
    color: #000;
    font-weight: bold;
  }
  .line_content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    line-height: 20px !important;
    text-align: center;
    font-size: 16px;
    position: relative;
    top: -10px;

    .line {
      margin-top: 5px;
      width: 150px;
      height: 1px;
      background: rgba(0, 0, 0, 0.65);
    }
  }
}
.ticket_time {
  padding-right: 10px;
  line-height: 30px;
  display: flex;
  justify-content: flex-start;
  align-items: right;
  flex-direction: column;
}
.time_div {
  font-weight: normal;
}
.flex-row {
  width: 100%;
  display: flex;
  justify-content: space-between !important;
}
</style>
